// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31Ff_","requiredAsterisk":"Info_requiredAsterisk__1M78j"};